<button mat-menu-item [matMenuTriggerFor]="partyMenu" [ngClass]="menuClass">
    <span class="fal fa-material fa-fw fa-building" aria-hidden="true"></span>
    <ng-content></ng-content>
</button>

<mat-menu #partyMenu="matMenu">
    <app-menu [menu]="menu" itemClass="adn-party-menu-item" activeItemClass="adn-party-menu-item-active"></app-menu>
</mat-menu>